export default __webpack_public_path__ + "static/media/pincho-hombre-verde.d6342985.png";